import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";

// A demo opens up TrustCall without the account owning the feature, so the access
// query has to be refetched alongside the account config to dismiss the paywall.
export function useActivateDemo() {
  const [isActivating, setIsActivating] = useState(false);
  const queryClient = useQueryClient();

  const activateDemo = async () => {
    setIsActivating(true);

    try {
      await callApi(TC.SETTINGS_ACTIVATE_DEMO, HttpMethod.POST);
      toast.success("Successfully activated demo in your account");
      await queryClient.invalidateQueries({ queryKey: ["trustcall"] });
      await queryClient.invalidateQueries({
        queryKey: ["signup", "trustcall"],
      });
    } catch {
      toast.error("Could not activate the demo. Please contact support@dnc.com.");
    } finally {
      setIsActivating(false);
    }
  };

  return { activateDemo, isActivating };
}
